import { render } from "./CampanasContent.vue?vue&type=template&id=737e5eb1"
import script from "./CampanasContent.vue?vue&type=script&lang=js"
export * from "./CampanasContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__